// extracted by css-extract-rspack-plugin
export default {"cls1":"ReferenceEvaluationPage-cls1_2Cp","cls2":"ReferenceEvaluationPage-cls2_43B ReferenceEvaluationPage-cls1_2Cp"};